var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.89,11.5A10.4,10.4,0,0,0,19,7.16l1.1-1.1L17.94,3.94,16.4,5.48a10.46,10.46,0,0,0-14.29,6l-.18.5.18.5A10.4,10.4,0,0,0,5,16.84l-1.1,1.1,2.12,2.12L7.6,18.52a10.41,10.41,0,0,0,4.4,1,10.51,10.51,0,0,0,9.89-7l.18-.5ZM5.13,12a7.47,7.47,0,0,1,9-4.2L7.17,14.71A7.53,7.53,0,0,1,5.13,12ZM12,16.5a7.58,7.58,0,0,1-2.08-.3l6.91-6.91a7.53,7.53,0,0,1,2,2.71A7.52,7.52,0,0,1,12,16.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.60533f4fd2e0388f326102f8654ca66a.svg";
export { ForwardRef as ReactComponent };